module.exports = __webpack_public_path__ + "static/media/L.d3da6e81.jpg";